import GradientContainer from "@app/components/gradient/gradient-container";
import Image from "next/image";

const MobileBeginAtStart = () => {
  return (
    <div className="md:px-12">
      <div className="flex flex-col py-10 px-6 space-y-3 text-center justify-center items-center">
        <p className="text-body-md 2xs:text-body-xl text-secondary-dark">
          The time to start saving is now.
        </p>
        <p className="h5 sm:h4 text-text-color-high-em-light">
          Begin at the start
        </p>
        <GradientContainer overrideClassName=" w-[150px] 2xs:w-[200px] h-2" />
      </div>

      <div className="flex flex-col px-8 md:px-0">
        <div className="flex flex-col  justify-center items-center space-y-10 ">
          <div>
            <Image
              src="/images/industries/begin.png"
              alt="begin"
              width={560}
              height={560}
            />
          </div>
          <div className="flex items-center space-y-5 flex-col justify-center">
            <div className="flex flex-col space-y-5">
              <p className="h4 text-text-color-high-em-light">
                Flex Options
              </p>
              <p className="text-text-color-mid-em-light">
                Sign-up with SimpleWaste and start your savings immediately. On our plan your value and savings increase over time.
                We provide flexible options with terms that fit your needs.
              </p>
            </div>
            <div className="flex flex-col space-y-5">
              <p className="h4 text-text-color-high-em-light">
                Administrative Control
              </p>
              <p className="text-text-color-mid-em-light">
                Maintain your facility operations with SimpleWaste innovation.
                Start using the platform that enables
                process, service, and vendor administration with ease.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default MobileBeginAtStart
